import { combineReducers } from 'redux';

import app from './app.reducer';
import config from './config.reducer';
import pages from './pages.reducer';
import modal from './modal.reducer';
import popups from './popups.reducer';
import contacts from './contacts.reducer';

const rootReducer = combineReducers({
	app,
	config,
	pages,
	modal,
	popups,
	contacts,
});

export default rootReducer;
